import en from './locale-english';
//@ts-ignore
import enE from 'element-ui/lib/locale/lang/en';
import fr from './locale-french';
//@ts-ignore
import frE from 'element-ui/lib/locale/lang/fr';

const locales = [
  { id: 'en', label: 'English' },
  { id: 'fr', label: 'Français' }
];

const messages = {
  en: { ...en, ...enE },
  'en-US': { ...en, ...enE },
  fr: { ...fr, ...frE },
  'fr-FR': { ...fr, ...frE }
};

function defaultLocale() {
  let locale = navigator.language;
  if (Array.isArray(navigator.languages)) locale = navigator.languages[0];
  if (Object.keys(messages).indexOf(locale) !== -1) return locale;
  return 'en';
}

export { defaultLocale, locales, messages };
